/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file RecommendedBySchedulingView.jsx
 * @author Daniel Aguirre
 * @description Recommended By Scheduling View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import DashboardBar from 'components/Charts/DashboardBar';
import { getMonthShortName } from 'commons/helpers/utils';
import styleGuideColors from 'commons/styleGuideColors';
import { useHistory } from 'react-router';

/**
 * RecommendedByScheduling View
 * @param { Object } dashboardStaffActions - DashboardStaffActions Actions.
 * @return { Node } React node.
 */

const MONTHS_LIMIT = 6;
const YEARS_NUMBER = 12;
const YEARS_LENGTH = 11;

function RecommendedBySchedulingView({ dashboardStaffActions, clinicId }) {
  const history = useHistory();
  const [chartData, setChartData] = useState(null);
  const { t: translate } = useTranslation();

  const { getRecommendedByScheduling } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    const currentMonth = new Date().getMonth();
    let labels = [];
    let labelsWithYear = [];
    let months = [];
    let years = [];
    const data = new Array(6).fill(0);

    if (resp?.data) {
      for (let index = 0; index < MONTHS_LIMIT; index += 1) {
        let currentYear = new Date().getFullYear();
        let monthIndex = currentMonth + index;
        if (monthIndex > YEARS_LENGTH) {
          monthIndex -= YEARS_NUMBER;
          currentYear += 1;
        }
        const month = getMonthShortName(monthIndex);
        labelsWithYear = [
          ...labelsWithYear,
          `${translate(month)}-${currentYear}`
        ];
        labels = [...labels, `${translate(month)}`];
        months = [...months, monthIndex + 1];
        years = [...years, currentYear];
      }
      resp.data.forEach((item) => {
        const splitDate = item?.mes_agendar?.split('-');
        if (splitDate) {
          const month = getMonthShortName(Number(splitDate[1] - 1));
          const year = Number(splitDate[0]);
          const monthIndex = labelsWithYear.indexOf(
            `${translate(month)}-${year}`
          );
          if (monthIndex !== -1) {
            const { cantidad } = item;
            data[monthIndex] = cantidad;
          }
        }
      });
      setChartData({
        labels,
        datasets: [
          { data, backgroundColor: styleGuideColors.baxterBrandPurple }
        ],
        years,
        months
      });
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    setChartData(null);
    getRecommendedByScheduling({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (index) => {
    const month = chartData.months[index];
    const year = chartData.years[index];
    const date = `${year}-${month}-01`;
    const totalItems = chartData.datasets[0].data[index];
    history.push(
      `/main/dashboard-detail/recommended-by-scheduling/${date}/${totalItems}`
    );
  };
  return (
    <DashboardCard id="F6" loading={!chartData}>
      <DashboardBar
        title={translate('dashboardStaff.recommendedByScheduling')}
        yTitle={translate('dashboardStaff.numberOfPatients')}
        displayLabels={false}
        dataValues={chartData}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
RecommendedBySchedulingView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getRecommendedByScheduling: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default RecommendedBySchedulingView;
